<nav #header *ngIf="renderMenu" class=" fixed-top headerStyle"
    [ngClass]="{'navbar2': this.companyParamsService.getFadeMenu()}"
    style='background-color: #051A72 !important;filter: drop-shadow(1px 1px 1px #6666664d);'>
    <div #header1 class="green containerMenu margin">
        <div *ngIf="companyParamsService.getHasLogoInformation()" class="tooltip fade show bs-tooltip-right"
            role="tooltip" id="tooltip164687" x-placement="right"
            style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(266px, 24px, 0px);">
            <div class="arrow" style="top: 8px;"></div>
            <div class="tooltip-inner">Your Logo Here</div>
        </div>
        <a *ngIf="!this.companyParamsService.getWebSite()" class="navbar-brand" target="_blank" class="navbar-brand"
            data-container=".green" data-toggle="tooltip" data-placement="right" title="Your Logo Here"
            style="display: flex; align-items: center;">
            <img src="assets/images/logos-header/dg.svg" height="50" alt="logo">
        </a>
        <a *ngIf="this.companyParamsService.getWebSite()" href="https://discovery-galapagos.com/en" class="navbar-brand"
            target="_blank" style="display: flex; align-items: center;">
            <input type="hidden" value="{{this.companyParamsService.getCompanyParams().logoFade}}" id="logoFade">
            <input type="hidden" value="{{this.companyParamsService.getCompanyParams().fadeMenu}}" id="fadeMenu">
            <img src="assets/images/logos-header/dg.svg" height="50" alt="logo">
        </a>
        <div class="containerMenu navbar-collapse collapse" style="justify-content: center;">
            <ul class="navbar-nav menuContainer" style="width: inherit; padding: 12px 30px;">
                <li class="nav-item menuItem"><a href="https://discovery-galapagos.com/en/" target="_blank">HOME</a>
                </li>
                <li class="nav-item menuItem"><a href="https://discovery-galapagos.com/en/tours/" target="_blank">DAILY
                        TOURS</a>
                </li>
                <li class="nav-item menuItem"><a href="https://discovery-galapagos.com/en/cruceros/"
                        target="_blank">CRUISES</a>
                </li>
                <li class="nav-item menuItem"><a href="https://discovery-galapagos.com/en/buceo/"
                        target="_blank">DIVING</a>
                </li>
                <li class="nav-item menuItem"><a href="https://discovery-galapagos.com/en/transporte-inter-islas/"
                        target="_blank">TRANSPORT</a>
                </li>
                <li class="nav-item menuItem"><a href="https://discovery-galapagos.com/en/rentas/"
                        target="_blank">RENTS</a></li>
                <li class="nav-item menuItem"><a href="https://discovery-galapagos.com/en/contactanos/"
                        target="_blank">CONTACT US</a></li>
            </ul>

        </div>
        <div class="button-container">
            <div style="display: flex; gap:3rem">
                <a href="https://discovery-galapagos.com/"><img src="assets/images/icons/flags/es_EC.png"
                        height="15"></a>
                <a href="https://discovery-galapagos.com/en/"><img src="assets/images/icons/flags/en_GB.png"
                        height="15"></a>
                <a href="https://discovery-galapagos.com/fr/"><img src="assets/images/icons/flags/fr_FR.png"
                        height="15"></a>
            </div>
            <div *ngIf="companyParamsService.getFiltersInterest()" class="wishlist tooltip-container">
                <app-heart-header></app-heart-header>
            </div>
        </div>


    </div>
    <div class="responsiveHeader">
        <div class="container green containerHeader"
            style="display:flex;justify-content:  space-between; flex-direction: row!important;">
            <img src="../assets/images/logos-header/dg.svg" width="150" />
            <a class="menuButton" (click)="renderMenu()" href="javascript:void()"
                style="display: flex;align-items: center;font-size: 20px;">
                <i class="fa fa-bars" style="border: 1px solid; padding: 5px;"></i>
            </a>
        </div>
        <div style="display: flex; gap:4.5rem; justify-content: center; padding: 10px;">
            <a href="https://discovery-galapagos.com/"><img src="assets/images/icons/flags/es_EC.png" height="15"></a>
            <a href="https://discovery-galapagos.com/en/"><img src="assets/images/icons/flags/en_GB.png"
                    height="15"></a>
            <a href="https://discovery-galapagos.com/fr/"><img src="assets/images/icons/flags/fr_FR.png"
                    height="15"></a>
        </div>
    </div>
    <ul style="width: inherit; display: none;" class="menuContainer" [ngClass]="showMenu ? 'showMenu':''">
        <li class="nav-item menuItem"><a href="https://discovery-galapagos.com/en/" target="_blank">HOME</a></li>
        <li class="nav-item menuItem"><a href="https://discovery-galapagos.com/en/tours/" target="_blank">DAILY
                TOURS</a>
        </li>
        <li class="nav-item menuItem"><a href="https://discovery-galapagos.com/en/cruceros/" target="_blank">CRUISES</a>
        </li>
        <li class="nav-item menuItem"><a href="https://discovery-galapagos.com/en/buceo/" target="_blank">DIVING</a>
        </li>
        <li class="nav-item menuItem"><a href="https://discovery-galapagos.com/en/transporte-inter-islas/"
                target="_blank">TRANSPORT</a>
        </li>
        <li class="nav-item menuItem"><a href="https://discovery-galapagos.com/en/rentas/" target="_blank">RENTS</a>
        </li>
        <li class="nav-item menuItem"><a href="https://discovery-galapagos.com/en/contactanos/" target="_blank">CONTACT
                US</a></li>
    </ul>
    <div *ngIf="companyParamsService.getFiltersInterest()" class="wishlist tooltip-container"
        [ngClass]="showMenu ? 'showMenu':''" style="width: inherit; display: none;">
        <app-heart-header></app-heart-header>
    </div>

</nav>